import Vue from "vue";

Vue.mixin({
    methods: {
        isEmpty(obj) {
            return typeof obj == 'undefined' || !(Object.keys(obj).length)
        }
    }
})